"use strict";

module.exports = function () {
  return {
    beforeFilters: this.$slots.beforeFilters ? this.$slots.beforeFilters : '',
    afterFilters: this.$slots.afterFilters ? this.$slots.afterFilters : '',
    prependHead: this.$slots.prependHead ? this.$slots.prependHead : '',
    beforeBody: this.$slots.beforeBody ? this.$slots.beforeBody : '',
    prependBody: this.$slots.prependBody ? this.$slots.prependBody : '',
    appendBody: this.$slots.appendBody ? this.$slots.appendBody : '',
    afterBody: this.$slots.afterBody ? this.$slots.afterBody : '',
    beforeFilter: this.$slots.beforeFilter ? this.$slots.beforeFilter : '',
    afterFilter: this.$slots.afterFilter ? this.$slots.afterFilter : '',
    afterFilterWrapper: this.$slots.afterFilterWrapper ? this.$slots.afterFilterWrapper : '',
    beforeSearch: this.$slots.beforeSearch ? this.$slots.beforeSearch : '',
    beforeLimit: this.$slots.beforeLimit ? this.$slots.beforeLimit : '',
    afterLimit: this.$slots.afterLimit ? this.$slots.afterLimit : '',
    beforeTable: this.$slots.beforeTable ? this.$slots.beforeTable : '',
    afterTable: this.$slots.afterTable ? this.$slots.afterTable : ''
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/slots.js
// module id = 1663
// module chunks = 64